import HelpersPlugin from './HelpersPlugin'
import ValidationPlugin from './ValidationPlugin'
import ActionsPlugin from './ActionsPlugin'

export default [
  HelpersPlugin,
  ValidationPlugin,
  ActionsPlugin
]
